
const ArticleSelector = function(element) {
    this.element = $(element);
    this.famille = this.element.find('[data-selector="famille"]');
    this.origine = this.element.find('[data-selector="origine"]');
    this.calibre = this.element.find('[data-selector="calibre"]');
    this.variete = this.element.find('[data-selector="variete"]');
    this.qualite = this.element.find('[data-selector="qualite"]');
    this.tiers = this.element.attr('data-tiers');

    this.famille.on('change', 'input', event => {
        this.disableOrigine();
        this.disableCalibre();
        this.disableVariete();
        this.disableQualite();
        this.refreshChoices();
    });

    // Mise à jour des labels des éléments
    this.element.on('change', '.btn-group-selector input[type=radio]', (event) => {
        let target = $(event.currentTarget),
            group = target.closest('.btn-group-selector');

        group.find('label').each((index, element) => {
            let label = $(element),
                input = label.find('input');

            label[input.prop('checked') ? 'addClass' : 'removeClass'].apply(label, ['active']);
        });
    })
};

$.extend(ArticleSelector.prototype, {
    disableOrigine: function() {
        this.origine.find('label').addClass('disabled').removeClass('active');
        this.origine.find(':checked').prop('checked', false);
    },

    disableCalibre: function() {
        this.calibre.find('label').addClass('disabled').removeClass('active');
        this.calibre.find(':checked').prop('checked', false);
    },

    disableVariete: function() {
        this.variete.find('label').addClass('disabled').removeClass('active');
        this.variete.find(':checked').prop('checked', false);
    },

    disableQualite: function() {
        this.qualite.find('label').addClass('disabled').removeClass('active');
        this.qualite.find(':checked').prop('checked', false);
    },

    refreshChoices: function () {
        let data = [];
        let adder = name => {
            return (index, element) => {
                const value = $(element).attr('value');
                if (value) {
                    data.push({
                        name: name,
                        value: value
                    });
                }
            };
        };

        if (this.tiers) {
            data.push({
                name: 'tiers',
                value: this.tiers
            });
        }

        this.famille.find(':checked').each(adder('famille'));
        this.origine.find(':checked').each(adder('origine'));
        this.calibre.find(':checked').each(adder('calibre'));
        this.variete.find(':checked').each(adder('variete'));

        $.ajax({
            url: this.element.attr('data-refresh-url'),
            data: data,
            dataType: 'json',
            success: response => {
                if (response.selection) {
                    $.each(response.selection, (field, id) => {
                        let element = this.element.find('[data-selector="'+field+'"]').find('[value=' + id + ']');

                        element.prop('checked', true);
                        element.closest('label').addClass('active');
                    });
                }

                if (response.available) {
                    $.each(response.available, (field, ids) => {
                        let container = this.element.find('[data-selector="' + field + '"]');

                        container.find('[value=""]').closest('label').removeClass('disabled');

                        ids.forEach(id => {
                            container.find('[value=' + id + ']').closest('label').removeClass('disabled');
                        })
                    });
                }
            }
        })
    }
});


const articleSelector = () => {
    const selector = 'div[data-article-selector]';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        new ArticleSelector(this);
    });
};

export { articleSelector }


// WEBPACK FOOTER //
// ./js/form/articleSelector.js